// source: https://github.com/TraceAir/osnova/blob/master/src/js/app/components/objects_forms/controls/measumenets_table/FadeOutContainer.tsx
import * as React from "react";

interface IFadeOutProps {
  show: boolean;
  delayMs?: number;
  durationMs?: number;
  onAnimationEnd: () => void;
  children: JSX.Element;
}

const FadeOutContainer = ({
  show = false,
  delayMs = 5000,
  durationMs = 600,
  onAnimationEnd,
  children,
}: IFadeOutProps) => {
  const child = React.Children.only(children);
  if (!child) {
    return children;
  }

  if (child && show) {
    return React.cloneElement(child, {
      ...child.props,
      style: {
        ...child.props.style,
        animation: `fadeOut ${durationMs}ms ${delayMs / 1000}s`,
      },
      onAnimationEnd,
    });
  }
  return children;
};

export default FadeOutContainer;
